import { render } from "./App.vue?vue&type=template&id=2ed50437"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2ed50437&lang=stylus"

import exportComponent from "/Volumes/ZTDisk/Mx_Zone/projects/xs/labfront/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__